import React, { useState, useEffect } from 'react';
import Indicator from './Indicator';
import config from "../config";
import LegendText from './LegendText';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

function LegendMap() {
    const [data, setData] = useState([]);
    const [hideLegend, setHideLegend] = useState(false);

    useEffect(() => {
        fetch(`${config.serverUrl}/api/indicators`)
            .then((response) => response.json())
            .then((fetchedData) => {
                setData(fetchedData);
            })
            .catch((error) => console.error('Error:', error));
    }, []);

    const tooltipTitle = hideLegend ? "Pokaż legendę" : "Ukryj legendę";

    return (
        <div className="legend">
            <div>
                <Tooltip title={tooltipTitle} placement={hideLegend ? "bottom" : "right"}>
                    <IconButton aria-label={tooltipTitle} color="secondary" onClick={() => setHideLegend(!hideLegend)}
                        style={{ backgroundColor: "white", borderRadius: "0px", border: "1px solid #ccc", borderBottom: "0px" }}>
                        {hideLegend ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                </Tooltip>
            </div>
            {!hideLegend && (
                <div className="map-legend scrollbar-style">
                    <LegendText text={"WSKAŹNIKI"} />
                    {Object.entries(data).filter(([_, indicator]) => indicator.integrated === false)
                        .sort((a, b) => a[1].name.localeCompare(b[1].name)).map(([key, item]) => (
                            <Indicator key={key} id={key} indicator_data={item} />
                        ))}
                    <LegendText text={"OCENY ZINTEGROWANE"} marginTop={3} />
                    {Object.entries(data).filter(([_, indicator]) => indicator.integrated === true)
                        .sort((a, b) => a[1].name.localeCompare(b[1].name)).map(([key, item]) => (
                            <Indicator key={key} id={key} indicator_data={item} />
                        ))}
                </div>
            )
            }
        </div>
    );
}

export default LegendMap;